import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import { useParams } from 'react-router';
import add from '../../icons/add.svg';
import routes from '../../../../routing/routes';
import Secured from '../../../Secured';
import UserRole from '../../../../model/currentuser/UserRole';

interface Props {
  setOpenDropdown: (isOpen: boolean) => void;
}

const AddPripomienkaAdminButton = ({ setOpenDropdown }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  return (
    <Secured
      allowForRoles={[UserRole.SUPERADMIN]}
    >
      <li key="Pridať pripomienku (admin)" className="action-item">
        <div className="icon-wrapper">
          <img src={add} className="icon" alt="Pridať pripomienku (admin)" />
        </div>
        <Link
          onClick={() => setOpenDropdown(false)}
          to={routes.admin.pripomienky.add.withParams(type, year, index)}
          className="button-inline-text"
        >Pridať pripomienku (admin)
        </Link>
      </li>
    </Secured>
  );
};

export default AddPripomienkaAdminButton;
